module.exports = __webpack_public_path__ + "static/media/icon-ventas-white.c563e51b.svg";